<template>
  <van-tabs 
    ref="tabsRef"
    class="ob-tabs"
    v-model:active="active"
    :ellipsis="false"
    :animated="false"
    :line-width="lineWidth"
    :lazy-render="lazyRender"
    @change="onChangeTab"
  >
    <van-tab 
      v-for="(tab, index) in tabs"
      :key="tab.name"
      :name="tab.name"
      :title="tab.title"
      :title-style="titleStyle"
    >
      <slot
        :name="tab.name"
      ></slot>
    </van-tab>
  </van-tabs>
</template>

<script>

export default {
  props: {
    tabs: {
      type: Array,
      default: null
    },
    titleStyle: {
      type: Object,
      default: () => {}
    },
    lazyRender: {
      type: Boolean,
      default: true
    }
  },
  emits: ['switch'],
  setup (props, { expose, emit }) {

    const { tabs, titleStyle } = toRefs(props)

    const tabsRef = ref(null)
    
    const active = ref(tabs.value[0].name || 0)
    const lineWidth = ref(0)

    async function onChangeTab (name) {
      await nextTick(() => {
        lineWidth.value = document.querySelector('.van-tab--active').querySelector('.van-tab__text').offsetWidth
      })
      tabsRef.value.resize()
      emit('switch', name)
    }

    onMounted(async () => {
      onChangeTab()
    })

    expose({
      active,
      onChangeTab
    })

    return {
      active,
      tabsRef,
      lineWidth,
      onChangeTab
    }
  }
}
</script>

<style lang="postcss" scoped>
  
</style>